import { FC } from 'react';
import { IconButton, IconButtonProps, styled } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';
import { PolarisIcon } from '@/exports/columnCommonComponents';

export type RoundIconButtonProps = IconButtonProps & {
  icon: string;
  iconSize?: number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const RoundIconButton: FC<RoundIconButtonProps> = ({ icon, iconSize = 18, ...props }) => (
  <StyledButton {...props}>
    <PolarisIcon icon={icon} width={iconSize} />
  </StyledButton>
);

export default RoundIconButton;

const StyledButton = styled(IconButton)`
  align-items: center;
  background-color: ${({ theme }) => (theme as FocusTheme).palette.neutral[80]};
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;

  &.Mui-disabled {
    background-color: ${({ theme }) => (theme as FocusTheme).palette.neutral[50]};
    color: ${({ theme }) => theme.palette.common.white};
    cursor: default;
    opacity: 0.3;

    & svg {
      color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;
